<template>
  <div class="section text-left">
    <h3 class="sr-only">Services</h3>
    <ul
      class="fa-ul"
      style="--list-margin-top: 0"
    >
      <li class="margin-bottom-sm padding-left-sm">
        <span class="fa-li">
          <font-awesome-icon
            :icon="context.download.icon"
            size="lg"
            :class="`${context.download.iconColor}`"
          />
        </span>
        <span
          v-if="!context.download.hasAccessToProDownloads"
          aria-label="Use Pro icons on the web through Kits and CDN. Offline downloads are not included."
          data-balloon-pos="up"
          data-balloon-length="large"
        >
          Online Icons Only
        </span>
        <span
          v-else
          aria-label="Gives you permission to download Font Awesome Pro icons."
          data-balloon-pos="up"
          data-balloon-length="large"
        >
          Pro Icon Downloads
        </span>
      </li>

      <li class="margin-bottom-sm padding-left-sm">
        <span class="fa-li">
          <font-awesome-icon
            :icon="context.license.icon"
            size="lg"
            :class="`${context.license.iconColor}`"
          />
        </span>

        <site-link
          v-if="!context.license.hasPerpetualLicense && !$dt.isBacker"
          :to="{ name: 'license.pro' }"
          aria-label="Web use included via Kits and CDN. Without a perpetual license, use is limited to the web. Lifetime access, self-hosting, desktop use, and native apps are not included."
          data-balloon-pos="up"
          data-balloon-length="large"
        >
          Limited License
        </site-link>
        <site-link
          v-else-if="context.license.hasProBackerLicenseOnly"
          :to="{ name: 'support', hash: '#font-awesome-5-kickstarter-pre-order-licenses' }"
          @click.native="$posthog.capture('support_link_click', { context: 'plan_card', location: 'backer_license' })"
        >
          Backer Pro License
        </site-link>
        <site-link
          v-else
          :to="{ name: 'license.pro' }"
          aria-label="Includes a perpetual license for Pro icons. You get lifetime access to the Pro icons available during your subscription, for use beyond Kits and CDN, including self-hosting, desktop use, and native apps."
          data-balloon-pos="up"
          data-balloon-length="large"
        >
          Perpetual License
        </site-link>
      </li>

      <li class="margin-bottom-sm padding-left-sm">
        <span class="fa-li">
          <font-awesome-icon
            :icon="context.support.icon"
            size="lg"
            :class="`${context.support.iconColor}`"
          />
        </span>
        <span
          v-if="!context.support.hasAccessToHumanSupport"
          aria-label="Get help from a real human when you need it. Seriously."
          data-balloon-pos="up"
          :class="serviceStylingUnavailable"
        >
          Actual Human&trade; Support
        </span>
        <span
          v-else
          aria-label="Get help from a real human when you need it. Seriously."
          data-balloon-pos="up"
        >
          Actual Human&trade; Support
        </span>
      </li>

      <li class="margin-bottom-sm padding-left-sm">
        <span class="fa-li">
          <font-awesome-icon
            :icon="context.packages.icon"
            size="lg"
            :class="`${context.packages.iconColor}`"
          />
        </span>

        <span
          v-if="!context.packages.hasAccessToPrivateNpm"
          aria-label="This plan does not include access to Font Awesome Pro private packages and plugins."
          data-balloon-pos="up"
          data-balloon-length="large"
          :class="serviceStylingUnavailable"
        >
          No Hosted Packages or Plugins
        </span>
        <span
          v-else
          aria-label="Access Font Awesome Pro private packages for building complex web apps."
          data-balloon-pos="up"
          data-balloon-length="large"
        >
          Pro Packages + Plugins
        </span>
      </li>
    </ul>
  </div>
</template>

<script>
  import pluralize from 'pluralize'
  import { ComponentContext } from '../mixins/aspects'

  export default {
    name: 'Services',

    mixins: [ComponentContext],

    props: {
      determinations: {
        type: Object,
        required: true
      }
    },

    data() {
      return {
        serviceStylingUnavailable: 'text-gray'
      }
    },

    methods: {
      pluralize
    }
  }
</script>
